StepController = App.loadClass 'grower::Angular/Data/PlantingRx/StepController'
TruthStripToolbar = App.loadClass 'grower::classes/data/planting_rx/TruthStripToolbar'

# Handles controlling the Truth Strip step of the Planting Rx
# process. This controller is pretty straightforward. Nearly everything
# it does is hooked in through the TruthStripToolbar (@toolbar) service.
# It does it's job as a controller, and links up the pieces.
#
# The only maybe confusing bit is the code for displaying the cross
# cropped visual layers (see the setUpMap method). This is only complex
# because it probably shouldn't be all in the controller. It'd be much
# nicer if one of our services could wrap that up a bit more. TODO
class exports.TruthStripsController extends StepController
    constructor: (@scope, @transitions, @map, @visualLayers, @layerManager, @toolbar, @loader) ->
        super(@scope, @transitions, @map)
        return if @scope.aborted

        @scope.enableTruthStrips = @enableTruthStrips
        @scope.disableTruthStrips = @disableTruthStrips
        @scope.createTruthStrip = @createTruthStrip
        @scope.toolbar_mode = @toolbar.getMode
        @scope.toolbar = @toolbar
        @scope.deleteArea = @deleteArea

        @pre_strips = @scope.rx.truth_strips.slice()

        @scope.$watch 'toolbar.areas', @syncAreas

        @setUpMap()

        # Generate and display the combined layer geometry (intersections of
        # the selected layers to use as the basis for the rx map).
        load_msg = @loader.overMapAndSidebar 'Loading...'
        # TODO: need to check if base layers have changed
        if @scope.rx.cross_crop_operations_id? and
                _.isEqual @scope.rx.visual_layers, @scope.rx.previous_visual_layers
            @getCombinedLayers(load_msg)
        else
            @visualLayers.combineLayers(@scope.rx.fields_id, @scope.rx.visual_layers)
                .then (result) =>
                    @scope.rx.previous_visual_layers = _.clone @scope.rx.visual_layers
                    @scope.rx.cross_crop_operations_id = result.cross_crop_operations_id
                    @getCombinedLayers(load_msg)
                .catch () =>
                    load_msg.hide()

        @scope.$on '$destroy', () =>
            @toolbar.hide()

    getCombinedLayers: (load_msg) =>
        @layerManager.get('CombinedLayers').display
            layers: @scope.rx.visual_layers
            field_id: @scope.rx.fields_id
            cross_crop_operations_id: @scope.rx.cross_crop_operations_id
        , @mapLayer
        .then () =>
            if @scope.rx.want_truth_strips
                @toolbar.areas = @pre_strips
                @toolbar.show()
        .finally () =>
            load_msg.hide()

    enableTruthStrips: () =>
        return if @scope.rx.want_truth_strips
        @scope.rx.want_truth_strips = true
        @syncAreas @toolbar.areas
        @toolbar.show()


    disableTruthStrips: () =>
        @scope.rx.want_truth_strips = false
        @scope.$parent.setValidity true

        # Clean up any truth strips when they disable them
        if @scope.rx.truth_strips.length > 0
            @scope.rx.truth_strips = []

        @toolbar.hide()


    createTruthStrip: () =>
        @toolbar.newStrip()


    deleteArea: (area) =>
        @toolbar.deleteArea(area)


    # Handles copying areas into the scope.rx
    # storage object, so they can be passed on to the
    # next step
    syncAreas: (areas) =>
        # deselect the buttons when drawing is done
        if @toolbar.toolbar?.drawControl?
            @toolbar.toolbar.drawControl.deselectAllButtons()

        if areas.length is 0 and @scope.rx.want_truth_strips
            @scope.$parent.setValidity false
        else
            @scope.$parent.setValidity true
        @scope.rx.truth_strips = areas

        for strip, index in @scope.rx.truth_strips
            strip.strip_id = index
